<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-width="1rem">
          <el-form-item label="导出类型" prop="checkRadio">
            <el-radio-group v-model="form.checkRadio">
              <el-radio :label="1">仅导出当前报表内容</el-radio>
              <el-radio :label="2">周期性报表</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="时间区间" prop="dateRange" v-if="form.checkRadio === 2">
            <el-date-picker
              v-model="form.dateRange"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {  downloadExcel } from "./api";
import { blobToText, downloadFileCustom } from "@/utils/tool";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "导出",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        "companyId": null,
        "checkRadio": 1,
        "dateRange": [],
        "date": "",
      },
      rules: {
        dateRange: [{ required: true, message: "时间区间不能为空", trigger: "blur"  }],
      },
    };
  },

  mounted() {},
  methods: {
    init(searchForm) {
      this.form.date = searchForm.date;
      this.form.companyId = searchForm.companyId;
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            companyId: this.form.companyId,
          };
          let param = {}
          let txt = ""
          if(this.form.checkRadio === 1) {
            txt = `司机业绩汇总报表(${this.form.date}).xlsx`
             param = Object.assign({}, par, {
              date: this.form.date
            });
          } else {
            txt = `司机业绩汇总报表(${this.form.dateRange[0]}-${this.form.dateRange[1]}).xlsx`
            param = Object.assign({}, par, {
              endTime: this.form.dateRange[1],
              startTime: this.form.dateRange[0],
            })
          }
          // // console.log("33333333333333333333333", param);
          downloadExcel(param)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              blobToText(res.data).then((data) => {
                downloadFileCustom(data, txt);
              });
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
